export function getTrackings(state) {
  return state.trackings;
}

export function getAnalytic(state) {
  return state.analytic;
}